import React from 'react';
import styles from './Logo.module.css';

const Logo = () => {
  return <span className={styles.logo}>☠ COVID-19</span>;
};

export default Logo;
